import { InjectionToken } from '@angular/core';

import { environment } from '../../../../environments/environment';

export interface MapboxConfig {
  accessToken: string;
  styleUrl: string;
}

export const MAPBOX_CONFIG = new InjectionToken<MapboxConfig>('MAPBOX_CONFIG', {
  providedIn: 'root',
  factory: () => environment.mapbox
});
